interface IProps {
   divClassName: string;
   labelClassName: string;
   labelText: string;
   id: string;
   htmlFor: string;
   dataModal: string;
   checked: boolean;
   onChange: () => void;
   onClick: (e: React.MouseEvent<HTMLElement>) => void;
}

const InputCheckBox = ({ divClassName, labelClassName, labelText, id, htmlFor, dataModal, checked, onChange, onClick }: IProps): JSX.Element => {
    return (
        <div className={divClassName}>
            <label htmlFor={htmlFor} data-modal={dataModal} className={labelClassName} onClick={onClick} >{labelText}</label>
            <input type="checkbox" id={id} checked={checked} onChange={onChange} />
        </div>
    )
}

export default InputCheckBox;   